export class Zalacznik {
  nazwaPliku: string;
  dataModyfikacji: Date;
  plik: string;
  format: string;
  czyZmieniono: boolean;
  sciezkaDoPliku: string;
}
